<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Razas</h1>

    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset" />

      <button class="btn-indigo" type="button" @click="openModal = true">
        <span>Agregar</span>
        <span class="hidden md:inline">Raza</span>
      </button>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nombre</th>
          <!-- Si usas especie_id en razas, habilita esta columna -->
           <th class="px-6 pt-6 pb-4">Especie</th>
        </tr>

        <tr v-for="r in razas.data" :key="r.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('razas.edit', r.id)" tabindex="-1">
              {{ r.nombre }}
            </inertia-link>
          </td>
        <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('razas.edit', r.id)" tabindex="-1">
              {{ r.especie }}
            </inertia-link>
          </td>
        </tr>

        <tr v-if="razas.data.length === 0">
          <td class="border-t px-6 py-4" colspan="1">No hay razas registradas</td>
        </tr>
      </table>
    </div>

    <pagination class="mt-6" :links="razas.links" />

    <!-- MODAL -->
    <div v-if="openModal" class="fixed inset-0 z-50 flex items-start justify-center px-4 pt-16">
      <div class="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/60" @click="closeModal"></div>

      <div class="relative bg-white rounded-md shadow-xl overflow-hidden w-full max-w-3xl">
        <div class="px-8 py-4 bg-gray-50 border-b border-gray-100 flex justify-between items-center">
          <div class="font-bold">Registrar Raza</div>
          <button type="button" class="text-gray-500 hover:text-gray-800" @click="closeModal">✕</button>
        </div>

        <form @submit.prevent="store">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="razaForm.nombre" :error="razaForm.errors.nombre"
              class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre de la raza" required />

            <!-- Si tu tabla razas tiene especie_id, habilita este select -->
            
            <select-input v-model="razaForm.especie_id" :error="razaForm.errors.especie_id"
              class="pr-6 pb-8 w-full lg:w-1/2" label="Especie">
              <option :value="null">Seleccione</option>
              <option v-for="e in especies" :key="e.id" :value="e.id">{{ e.nombre }}</option>
            </select-input>
            
          </div>

          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
            <loading-button :loading="razaForm.processing" class="btn-indigo" type="submit">
              Guardar Raza
            </loading-button>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Razas' },
  layout: Layout,
  components: { Pagination, SearchFilter, TextInput, SelectInput, LoadingButton },
  props: {
    filters: [Object, Array],
    razas: Object,
    especies: Array,
  },
  data() {
    return {
      openModal: false,
      form: {
        search: this.filters && this.filters.search ? this.filters.search : null,
      },
      razaForm: this.$inertia.form({
        nombre: null,
        especie_id: null,
      }),
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('razas.index'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    closeModal() {
      this.openModal = false
      this.razaForm.clearErrors()
    },
    store() {
      this.razaForm.post(this.route('razas.store'), {
        preserveScroll: true,
        onSuccess: () => {
          this.openModal = false
          this.razaForm.reset()
        },
      })
    },
  },
}
</script>